import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../App';
import { SeoContext } from '../data/seo/SeoContextProvider';
import {isSeoSettingsNoFollow } from '../data/seo/seoUtils';
import { useAbsolutePath } from '../data/seo/seoRouteUtils';
import { getLiveSportPathname } from '../data/utils/getLiveSportPathname';
import { getLiveSportWindowLocationHash } from '../data/utils/getLiveSportWindowLocationHash';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { stringCapitalize } from '../data/utils/stringCapitalize';

function SportSelection(props) {
    const appContext = React.useContext(AppContext);
    const seoContext = React.useContext(SeoContext);
    const selected = props.selected ? ' selected' : '';
    const icoSport = iconSportCssClass(props.id, props.iconClass);
    const sportPath = [props.urlPath, props.urlPathSuffix].join('')
    const relativeSportPath = useAbsolutePath(sportPath,null,props.urlPathSeo,true);  
    const noFollow = props.isLiveSuite || isSeoSettingsNoFollow(props.urlPathSeoSettings);
    const sportSelectionRef = useRef();
    
    useEffect(() => {
        try {
            if(props.selected){
                sportSelectionRef?.current?.scrollIntoView(false);
            }
        }catch(err){
            console.log(err);
        }
       
    },[props.selected]);

    function handleOnClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            props.handleClick();
        }else{
            if(!props.isLiveSuite){
                appContext.setHandleOpenFromPath(true);
                seoContext.refreshPathname(null,appContext.location.current);
                //props.handleClick();
            }
        }
    }
    
    return (
        /* <Link to={props.isLiveSuite?getLiveSportPathname()+getLiveSportWindowLocationHash(props.id):encodeURI(relativeSportPath)} onClick={handleOnClick} {...(noFollow ? {rel: 'nofollow'}:{})}  > */
        <Link to={encodeURI(relativeSportPath)} style={{order: props.order}} onClick={handleOnClick} {...(noFollow ? {rel: 'nofollow'}:{})}  >
            <div ref={sportSelectionRef} id={"nav-live-sport-"+ props.id} className={`nav-slider-item-container sport-img-slider ${selected}`} onClick={props.handleClick}>
                <div className="sport-img-slider-count">{props.eventsCount || 0}</div>
                <div className="sport-img-container">
                    <div className={`sport-img ${icoSport}`}></div>
                </div>
                <div className="nav-slider-item">{stringCapitalize(props.descrizione)}</div>
            </div>
        </Link>
    );
}

export default SportSelection;